(function () {
    const LOCAL_DELIVERY_KEY = "local_delivery_eligible_zip";

    // All eligible NYC zipcodes - copy from your component
    const ELIGIBLE_ZIPS =
        window.LOCAL_DELIVERY_CONFIG && window.LOCAL_DELIVERY_CONFIG.eligibleZips
            ? window.LOCAL_DELIVERY_CONFIG.eligibleZips.map((zip) => zip.trim())
            : [];
    console.log("Eligible Zips:", ELIGIBLE_ZIPS);
    function isLocalPage() {
        const pathname = window.location.pathname;

        // Condition 1: Main local delivery page /pages/nyc
        if (pathname === "/pages/nyc" || pathname === "/pages/nyc/") {
            return true;
        }

        // Condition 2: Collection with /local in URL (e.g., /collections/collection_name/local)
        if (pathname.includes("/collections/") && pathname.includes("/local")) {
            return true;
        }

        // Condition 3: Product page with 'local' tag (checked via Liquid, this is triggered if you reach here)
        // This is passed via a data attribute we'll set in Liquid
        const productElement = document.querySelector(
            '[data-is-local-product="true"]'
        );
        if (productElement) {
            console.log("Local product page detected");
            return true;
        }
        if (
            pathname.includes("/search") ||
            pathname.includes("/pages/about-us") ||
            pathname.includes("/pages/halal-certification") ||
            pathname.includes("/pages/terms-and-conditions") ||
            pathname.includes("/pages/privacy-policy") ||
            pathname.includes("/pages/refund-policy")
        ) {
            console.log("Neutral page detected");
            return true;
        }


        return false;
    }

    function isEligible(zip) {
        return /^\d{5}$/.test(zip) && ELIGIBLE_ZIPS.includes(zip);
    }

    function clearDeliveryStatus() {
        localStorage.removeItem(LOCAL_DELIVERY_KEY);
    }

    function setDeliveryStatus(zip) {
        if (isEligible(zip)) {
            localStorage.setItem(LOCAL_DELIVERY_KEY, zip);
            return true;
        }
        return false;
    }

    function getDeliveryStatus() {
        return localStorage.getItem(LOCAL_DELIVERY_KEY);
    }

    function showEligibilityModal() {
        const storedZip = getDeliveryStatus();

        // If user has valid zip stored, allow access
        if (storedZip && isEligible(storedZip)) {
            return;
        }
        if (
            window.location.pathname === "search" ||
            window.location.pathname === "/search" ||
            window.location.pathname === "pages/terms-and-conditions" ||
            window.location.pathname === "/pages/terms-and-conditions" ||
            window.location.pathname === "pages/about-us" ||
            window.location.pathname === "/pages/about-us" ||
            window.location.pathname === "pages/halal-certification" ||
            window.location.pathname === "/pages/halal-certification" ||
            window.location.pathname === "pages/privacy-policy" ||
            window.location.pathname === "/pages/privacy-policy" ||
            window.location.pathname === "pages/refund-policy" ||
            window.location.pathname === "/pages/refund-policy"
        ) {
            // Allow access on neutral page
            console.log("Neutral page - bypassing delivery modal");
            return;
        }
        // No valid zip, show modal
        showModal();
    }

    function showModal() {
        // Prevent multiple modals
        if (document.getElementById("delivery-eligibility-modal")) {
            return;
        }

        const modal = document.createElement("div");
        modal.id = "delivery-eligibility-modal";
        modal.innerHTML = `
        <div class="delivery-modal-overlay">
        <div class="delivery-modal-content">
            <button class="modal-close" aria-label="Go back to nationwide delivery" title="Go back to nationwide delivery"></button>
            
            <div class="delivery-header">

            <h2 class="delivery-title">New York Same and Next Day Delivery</h2>
            <p class="delivery-subtitle">Enter your 5-digit ZIP code to check if you're eligible.</p>
            </div>
            
            <div class="delivery-form-container">
            <div class="form-content">
                <label class="form-label">Verify Your Location</label>
                
                <div class="input-wrapper">
                <input 
                    type="text" 
                    id="modalZipInput" 
                    class="zip-input" 
                    placeholder="Enter ZIP code"
                    maxlength="5"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    aria-label="ZIP code input"
                >
                <span class="input-icon">📍</span>
                </div>
                
                <button id="modalCheckBtn" class="check-btn">Verify Eligibility</button>
                
                <p class="helper-text"></p>
                
                <div id="modalResultMessage" class="result-message"></div>
                <button id="modalBackBtn" class="modal-back-btn" style="display: none;" onclick="window.location.href='/'">Back to Nationwide Delivery</button>    
            </div>
            </div>
        </div>
        </div>
    `;

        document.body.appendChild(modal);
        attachModalListeners();

        // Focus on input for accessibility
        setTimeout(() => {
            document.getElementById("modalZipInput")?.focus();
        }, 100);
    }

    function attachModalListeners() {
        const checkBtn = document.getElementById("modalCheckBtn");
        const zipInput = document.getElementById("modalZipInput");
        const resultMsg = document.getElementById("modalResultMessage");
        const closeBtn = document.querySelector(".modal-close");
        const backBtn = document.getElementById("modalBackBtn");
        const modal = document.getElementById("delivery-eligibility-modal");

        function checkAndRespond() {
            const zip = zipInput.value.trim();

            if (!isEligible(zip)) {
                resultMsg.innerHTML =
                    '<span class="result-icon">✗</span><span class="result-text">Not eligible for local delivery in your area.</span>';
                resultMsg.classList.remove("eligible");
                resultMsg.classList.add("show", "ineligible");
                backBtn.style.display = "block";
                clearDeliveryStatus();
                return;
            }

            // Eligible
            resultMsg.innerHTML =
                '<span class="result-icon">✓</span><span class="result-text">You\'re eligible! Granting access...</span>';
            resultMsg.classList.remove("ineligible");    
            resultMsg.classList.add("show", "eligible");
            setDeliveryStatus(zip);

            setTimeout(() => {
                closeModal();
            }, 1000);
        }

        checkBtn?.addEventListener("click", checkAndRespond);
        zipInput?.addEventListener("keypress", (e) => {
            if (e.key === "Enter") {
                checkAndRespond();
            }
        });

        zipInput?.addEventListener("focus", () => {
            resultMsg.classList.remove("show");
            backBtn.style.display = "none";
        });

        closeBtn?.addEventListener("click", () => {
            window.location.href = "/";
        });

        backBtn?.addEventListener("click", () => {
            window.location.href = "/";
        });
    }

    function closeModal() {
        const modal = document.getElementById("delivery-eligibility-modal");
        if (modal) {
            modal.style.opacity = "0";
            setTimeout(() => {
                modal.remove();
            }, 300);
        }
    }

    function initializePageGuard() {
        if (isLocalPage()) {
            // User is on a local page, check eligibility
            showEligibilityModal();
        } else {
            // User is on a global page, clear local delivery status
            clearDeliveryStatus();
        }
    }

    // Run when DOM is ready
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initializePageGuard);
    } else {
        initializePageGuard();
    }

    // Expose functions globally
    window.LocalDeliveryGuard = {
        setDeliveryStatus,
        getDeliveryStatus,
        isEligible,
        clearDeliveryStatus,
        isLocalPage,
    };
})();



